export default __webpack_public_path__ + "static/media/KristinGretaEric.2522850a.jpg";